import { Storage } from 'Util/Capacitors/utils';

// May change to some random key per project
const ACCESS_TOKEN = 'accessToken';

const accessTokenService = () => {
  const saveAccessToken = async (accessToken) => {
    localStorage.setItem(ACCESS_TOKEN, accessToken);
    Storage.setItem(ACCESS_TOKEN, accessToken);
  };

  const removeAccessToken = async () => {
    localStorage.removeItem(ACCESS_TOKEN);
    Storage.removeItem(ACCESS_TOKEN);
  };

  const getAccessToken = () => {
    return localStorage.getItem(ACCESS_TOKEN);
  };

  return {
    saveAccessToken,
    removeAccessToken,
    getAccessToken,
  };
};

export { accessTokenService };
